import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import BillingRecordAdminList from './BillingRecordAdminList';

function TablePage(props) {
  return (
    <ScopedCssBaseline>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <BillingRecordAdminList />
      </Box>
    </ScopedCssBaseline>
  );
}

export default TablePage;
